<template>
  <div>
    <q-dialog v-model="show" @input="onUpdateModel" @hide="onClose">
      <q-card class="q-card-container">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6"><translate>BULK_BIND_COST_CENTER</translate></div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-form @submit="confirmBulkBind" class="q-gutter-md">
          <q-card-section class="form">
            <q-select emit-value map-options outlined v-model="serviceCostCenterModel" :options="filteredServiceCostCenterOptions"
              :label="$gettext('COST_CENTER')" :rules="[ val => val != '' && val != null || this.$gettext('REQUIRED_FIELD')]" data-testid="serviceCostCenterComboOption"
              lazy-rules
              use-input
              input-debounce="0"
              @filter="filterCostCenter"
               />
          </q-card-section>
          <q-card-section class="buttons">
            <q-btn v-close-popup color="grey">
              <translate>CANCEL</translate>
            </q-btn>
            <q-btn color="primary" type="submit" data-testid="updateCostCenterActionButton">
              <translate>UPDATE_BUTTON</translate>
            </q-btn>
          </q-card-section>
        </q-form>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'

@Component({
  name: 'CostCenterSelectionModal',
  components: {},
  props: {
    params: Object,
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show (newValue) {
      if (newValue) {
        this.loadOptions()
      }
    }
  }
})
class CostCenterSelectionModal extends Vue {
  serviceCostCenterOptions = []
  filteredServiceCostCenterOptions = []
  serviceCostCenterModel = ''

  filterCostCenter (val, update) {
    if (val === '') {
      update(() => {
        this.filteredServiceCostCenterOptions = this.serviceCostCenterOptions
      })
      return
    }

    update(() => {
      const needle = val.toLowerCase()
      this.filteredServiceCostCenterOptions = this.serviceCostCenterOptions.filter(
        v => v.label.toLowerCase().indexOf(needle) > -1
      )
    })
  }

  async loadOptions () {
    try {
      if (!this.params || !this.params.selected || !this.params.selected.length) {
        return
      }
      const firstSelected = this.params.selected[0]
      const params = {
        clientType: firstSelected.clientType,
        serviceType: firstSelected.serviceType,
        contract_client_company_organizationalStructure_name: firstSelected.organizationalStructureName,
        organizationalStructure: firstSelected.organizationalStructure
      }

      const forms = await repository.resolve('contractItemCostCenter.bulkBindCostCenter', params)
      // Os dados do combo estão em relacionamentos.serviceCostCenter
      if (forms && forms[0] && forms[0].relacionamentos && forms[0].relacionamentos.serviceCostCenter) {
        this.serviceCostCenterOptions = forms[0].relacionamentos.serviceCostCenter
        this.filteredServiceCostCenterOptions = forms[0].relacionamentos.serviceCostCenter
      }
    } catch (error) {
      console.error('Error loading cost center options:', error)
      messageBox.error(this.$gettext('ERROR_LOADING_FORM'))
    }
  }

  onClose () {
    this.serviceCostCenterModel = ''
  }

  onUpdateModel (val) {
    this.$emit('update:model-value', val)
  }

  async confirmBulkBind () {
    if (!this.serviceCostCenterModel) {
      messageBox.warn(this.$gettext('REQUIRED_FIELDS_NOT_FILLED'))
      return
    }

    try {
      const ids = this.params.selected.map(item => item.id)
      await repository.resolveLogic('contractItemCostCenter.bulkBindCostCenter', {
        ids: ids,
        serviceCostCenter: this.serviceCostCenterModel
      })

      this.onUpdateModel(false)
      messageBox.success(this.$gettext('COST_CENTER_BOUND_SUCCESSFULLY'), 'top-right')
      this.params.refresh()
    } catch (error) {
      console.error('Error binding cost center:', error)
      messageBox.error(this.$gettext('ERROR_BINDING_COST_CENTER'))
    }
  }
}
export default CostCenterSelectionModal
</script>
<style scoped>
.q-card-container {
  width: 600px;
}

.form {
  margin-top: 5%;
}

.buttons {
  padding: 0 0 16px 0;
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}
</style>
